module.exports = __webpack_public_path__ + "img/female1.ba35c15b.jpg";